// Universal ActionButton,
// mainly in the process of asynchronous callback about onClick,
// supports automatic internalLoading state of Button, no need to hard code to control the internalLoading state
import React, { useState } from 'react';
import { Button } from '../Button';
import { useTranslation } from '../hooks/useTranslation';
import { triggerAriaMessage } from './a11yUtils';
export const ActionButton = (props) => {
    const { onClick, afterAction, loading } = props;
    const { t } = useTranslation('Shared');
    const originOnClick = onClick;
    const [internalLoading, setInternalLoading] = useState(false);
    const handleOnClick = (e) => {
        if (typeof originOnClick !== 'function') {
            afterAction?.();
            return;
        }
        const returnValue = originOnClick(e);
        if (Object.prototype.toString.call(returnValue) === '[object Promise]') {
            setInternalLoading(true);
            triggerAriaMessage(t('loading'));
            returnValue
                ?.then(() => {
                setInternalLoading(false);
                afterAction?.();
            })
                .catch((err) => {
                // When an error is caught, cancel the button's internalLoading state.
                setInternalLoading(false);
                // Adding this code is mainly to print out the caught error as it is.
                // Avoid onClick error is caught but not displayed.
                // eslint-disable-next-line no-console
                console.error(err);
            });
        }
        else {
            afterAction?.();
        }
    };
    return (React.createElement(Button, { ...props, loading: internalLoading || loading, onClick: handleOnClick }));
};
